export default {
  methods: {
    getStatusBadges(campaign) {
      if (!campaign) {
        return []
      }

      const status = campaign.status?.toLowerCase()

      if (status === 'deleted') {
        return [{ label: campaign.status, color: 'danger' }]
      }

      if (!campaign.status) {
        return []
      }

      const colorByStatus = {
        inreview: 'info',
        active: 'success',
        rejected: 'danger'
      }
      let label = status === 'inreview' ? 'Review Pending' : campaign.status
      let color = colorByStatus[status] || 'warning'

      if (campaign.isPaused) {
        const pausedLabel = campaign.isStrictPause ? 'Strictly Paused' : 'Paused'
        label = status === 'active' ? pausedLabel : `${label} (${pausedLabel})`
        color = 'warning'
      }

      return [{ label, color }]
    },

    canCampaignBeResumed(campaign) {
      return campaign?.status?.toLowerCase() === 'paused' || campaign?.isPaused
    },

    canCampaignBeArchived(campaign) {
      return campaign?.status?.toLowerCase() !== 'deleted'
    },
  }
}
